import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_text",
  "use": "icon-control_text-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_text\"><g><path d=\"M14 2v1.674H3V2z\" /><path d=\"M9.325 2.837V14h-1.65V2.837z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol